var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('loader-item',{attrs:{"isLoader":this.$root.fullscreenLoading}}),(this.$root.resetPasswordDialog)?_c('resetPassword'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }